import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'

// Re-export UaeMpciApiUrls in nested structure for backward compatibility
const MPCIApiUrls = {
  MANIFEST: {
    GET: UaeMpciApiUrls.GET,
    POST: UaeMpciApiUrls.POST,
    PUT: UaeMpciApiUrls.PUT,
    DELETE: UaeMpciApiUrls.DELETE,
    EXPORT: UaeMpciApiUrls.EXPORT,
    SUBMIT: UaeMpciApiUrls.SUBMIT
  },
  VESSEL_MASTER: {
    GET: UaeMpciApiUrls.VESSEL_MASTER_GET,
    POST: UaeMpciApiUrls.VESSEL_MASTER_POST,
    PUT: UaeMpciApiUrls.VESSEL_MASTER_PUT,
    DELETE: UaeMpciApiUrls.VESSEL_MASTER_DELETE,
    LIST: UaeMpciApiUrls.VESSEL_MASTER_LIST,
          COPY: UaeMpciApiUrls.VESSEL_MASTER_CLONE,
    CHECK_IMO: UaeMpciApiUrls.VESSEL_MASTER_CHECK_IMO
  },
  PARTY_MASTER: {
    GET: UaeMpciApiUrls.PARTY_MASTER_GET,
    POST: UaeMpciApiUrls.PARTY_MASTER_POST,
    PUT: UaeMpciApiUrls.PARTY_MASTER_PUT,
    DELETE: UaeMpciApiUrls.PARTY_MASTER_DELETE,
    LIST: UaeMpciApiUrls.PARTY_MASTER_LIST,
          COPY: UaeMpciApiUrls.PARTY_MASTER_CLONE,
    SEARCH: UaeMpciApiUrls.PARTY_MASTER_SEARCH
  },
  MASTER_BILL: {
    GET: UaeMpciApiUrls.MASTER_BILL_GET,
    POST: UaeMpciApiUrls.MASTER_BILL_POST,
    PUT: UaeMpciApiUrls.MASTER_BILL_PUT,
    DELETE: UaeMpciApiUrls.MASTER_BILL_DELETE,
    LIST: UaeMpciApiUrls.MASTER_BILL_LIST,
        SUBMIT: UaeMpciApiUrls.MASTER_BILL_SUBMIT,
    CANCEL: UaeMpciApiUrls.MASTER_BILL_CANCEL,
    COPY: UaeMpciApiUrls.MASTER_BILL_CLONE,
    DELETE_MULTIPLE: UaeMpciApiUrls.MASTER_BILL_DELETE_MULTIPLE,
    SUBMIT_MULTIPLE: UaeMpciApiUrls.MASTER_BILL_SUBMIT_MULTIPLE
  },
  HOUSE_BILL: {
    GET: UaeMpciApiUrls.HOUSE_BILL_GET,
    POST: UaeMpciApiUrls.HOUSE_BILL_POST,
    PUT: UaeMpciApiUrls.HOUSE_BILL_PUT,
    DELETE: UaeMpciApiUrls.HOUSE_BILL_DELETE,
    LIST: UaeMpciApiUrls.HOUSE_BILL_LIST,
        SUBMIT: UaeMpciApiUrls.HOUSE_BILL_SUBMIT,
    CANCEL: UaeMpciApiUrls.HOUSE_BILL_CANCEL,
    COPY: UaeMpciApiUrls.HOUSE_BILL_CLONE,
    DELETE_MULTIPLE: UaeMpciApiUrls.HOUSE_BILL_DELETE_MULTIPLE,
    SUBMIT_MULTIPLE: UaeMpciApiUrls.HOUSE_BILL_SUBMIT_MULTIPLE
  },
  DASHBOARD: {
    KPI: UaeMpciApiUrls.DASHBOARD_KPI,
    STATUS_COUNTS: UaeMpciApiUrls.DASHBOARD_STATUS_COUNTS
  },
  UPLOAD: {
    POST: UaeMpciApiUrls.EXCEL_UPLOAD_POST,
    LIST: UaeMpciApiUrls.EXCEL_UPLOAD_LIST,
    TEMPLATE_DOWNLOAD: UaeMpciApiUrls.EXCEL_UPLOAD_TEMPLATE_DOWNLOAD,
    REPORT: UaeMpciApiUrls.EXCEL_UPLOAD_REPORT,
    SUBMIT_DRAFTS: UaeMpciApiUrls.EXCEL_UPLOAD_SUBMIT_DRAFTS,
    EDIT_DRAFTS: UaeMpciApiUrls.EXCEL_UPLOAD_EDIT_DRAFTS,
    DELETE_DRAFTS: UaeMpciApiUrls.EXCEL_UPLOAD_DELETE_DRAFTS
  },
    REPORTS: {
    // POST /report/generate — Postman verified
    GENERATE: UaeMpciApiUrls.REPORT_GENERATE,
    // Polling + download: use FILE_DOWNLOAD_LIST (GET /file-download/list)
    FILE_DOWNLOAD_LIST: UaeMpciApiUrls.FILE_DOWNLOAD_LIST
  },
  AUDIT_LOG: {
    LIST: UaeMpciApiUrls.AUDIT_LOG_GET
  }
}

export default MPCIApiUrls